module.exports = __webpack_public_path__ + "static/media/August_2026_2.8796dc4d.webp";